import React, { useEffect, useState, useMemo } from 'react';
import { Group, Rect, Image as KonvaImage, Text } from 'react-konva';
import { getApplianceItem } from '../../constants/catalogItems';

/**
 * Renderizador de Item do Catálogo 2D dentro do Konva Canvas
 * Converte o SVG técnico paramétrico para uma imagem HTML nativa em memória via Blob.
 */
const ApplianceElement = ({ element, isSelected, onClick, onTap }) => {
  const [imageObj, setImageObj] = useState(null);
  const catalogDef = useMemo(() => getApplianceItem(element.svgId), [element.svgId]);

  useEffect(() => {
    if (!catalogDef) return;

    const strokeColor = isSelected ? '#ef4444' : '#0f172a';
    const strokeWidth = isSelected ? 2.5 : 2;
    const fillColor = '#ffffff';

    const svgInner = catalogDef.getSvgInner
      ? catalogDef.getSvgInner({ stroke: strokeColor, strokeWidth, fill: fillColor })
      : '';

    const width = catalogDef.defaultWidth;
    const height = catalogDef.defaultHeight;

    const fullSvg = `
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${width} ${height}" width="${width}" height="${height}">
        ${svgInner}
      </svg>
    `.trim();

    const blob = new Blob([fullSvg], { type: 'image/svg+xml;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const img = new window.Image();
    img.src = url;
    img.onload = () => {
      setImageObj(img);
    };

    return () => {
      URL.revokeObjectURL(url);
    };
  }, [catalogDef, isSelected]);

  const width = element.width || catalogDef?.defaultWidth || 60;
  const height = element.height || catalogDef?.defaultHeight || 60;
  const rotation = element.rotation || 0;

  return (
    <Group
      x={element.x}
      y={element.y}
      width={width}
      height={height}
      rotation={rotation}
      offset={{ x: width / 2, y: height / 2 }}
      onClick={onClick}
      onTap={onTap}
    >
      {/* Imagem SVG Renderizada */}
      {imageObj && (
        <KonvaImage
          image={imageObj}
          width={width}
          height={height}
        />
      )}

      {/* Bounding box de seleção quando ativo */}
      {isSelected && (
        <Rect
          x={0}
          y={0}
          width={width}
          height={height}
          stroke="#ef4444"
          strokeWidth={2}
          dash={[4, 4]}
          fill="rgba(239, 68, 68, 0.05)"
        />
      )}

      {/* Rótulo de dimensões técnicas */}
      <Text
        text={`${Math.round(width)}×${Math.round(height)}`}
        x={width / 2 - 20}
        y={height + 4}
        fontSize={10}
        fontFamily="sans-serif"
        fill={isSelected ? '#ef4444' : '#64748b'}
        listening={false}
      />
    </Group>
  );
};

export default ApplianceElement;
